<template>
  <v-container fluid pa-0>
    <OdocTable />
  </v-container>
</template>

<script>
import OdocTable from '@/modules/odoc/components/OdocTable'

export default {
  name: 'Duwa',

  components: {
    OdocTable
  }
}
</script>
